// ? When adding columns, remember to update model on the backend.
// ? especially the filterSchema.

import { dateOf } from '@/lib/time';

export default {
	columns : {
		permitsKey : {
			title  : 'ID',
			sort   : 'number',
			filter : 'string',
			index  : true,
			hidden : false,
			order  : 0,
		},

		number : {
			title  : 'Permit #',
			sort   : 'number',
			filter : 'string',
			hidden : false,
			order  : 1,
		},

		status : {
			title  : 'Status',
			sort   : 'string',
			filter : 'dropdown',
			index  : true,
			hidden : false,
			order  : 2,
		},

		facilityNumber : {
			title        : 'Facility #',
			sort         : 'number',
			filter       : 'string',
			hidden       : false,
			order        : 3,
			filterColumn : 'facility.number',
		},

		facilityName : {
			title        : 'Facility Name',
			sort         : 'string',
			filter       : 'string',
			index        : true,
			weight       : 10,
			hidden       : false,
			order        : 4,
			filterColumn : 'facility.name',
		},

		permittee : {
			title  : 'Permittee',
			sort   : 'string',
			filter : 'string',
			index  : true,
			hidden : false,
			order  : 5,
		},

		permitsTypeDescription : {
			title        : 'Type',
			sort         : 'string',
			filter       : 'dropdown',
			order        : 6,
			filterColumn : 'permitsType.description',
		},

		jobNumber : {
			title        : 'Job/Misc. Job #',
			sort         : 'number',
			filter       : 'string',
			hidden       : false,
			order        : 7,
			filterColumn : 'job.number',
		},

		issuedBy : {
			title  : 'Issued By',
			sort   : 'string',
			filter : 'string',
			index  : true,
			hidden : false,
			order  : 8,
		},

		summary : {
			title  : 'Description',
			sort   : 'string',
			filter : 'string',
			index  : true,
			hidden : false,
			order  : 9,
		},

		dateIssued : {
			title         : 'Date Issued',
			sort          : 'date',
			filter        : 'date',
			hidden        : false,
			order         : 10,
			transformText : dateOf,
		},

		dateStarted : {
			title         : 'Date Started',
			sort          : 'date',
			filter        : 'date',
			hidden        : false,
			order         : 11,
			transformText : dateOf,
		},

		dateFinished : {
			title         : 'DateFinished',
			sort          : 'date',
			filter        : 'date',
			hidden        : false,
			order         : 12,
			transformText : dateOf,
		},

		dateFinalInspection : {
			title         : 'Date Final Inspection',
			sort          : 'date',
			filter        : 'date',
			hidden        : false,
			order         : 13,
			transformText : dateOf,
		},

		dateDepositReturned : {
			title         : 'Date Deposit Returned',
			sort          : 'date',
			filter        : 'date',
			hidden        : false,
			order         : 14,
			transformText : dateOf,
		},

		dateReminder : {
			title         : 'Date Reminder',
			sort          : 'date',
			filter        : 'date',
			hidden        : false,
			order         : 15,
			transformText : dateOf,
		},

		permitFee : {
			title  : 'Permit Fee',
			sort   : 'number',
			filter : 'string',
			order  : 16,
		},

		inspectionFee : {
			title  : 'Inspection Fee',
			sort   : 'number',
			filter : 'string',
			order  : 17,
		},

		materialsFee : {
			title  : 'Materials Fee',
			sort   : 'number',
			filter : 'string',
			order  : 18,
		},

		shutdownFee : {
			title  : 'Shutdown Fee',
			sort   : 'number',
			filter : 'string',
			order  : 19,
		},

		depositFee : {
			title  : 'Deposit Fee',
			sort   : 'number',
			filter : 'string',
			order  : 20,
		},

		depositDeductions : {
			title  : 'Deposit Deductions',
			sort   : 'number',
			filter : 'string',
			order  : 21,
		},
		locationDescription : {
			title        : 'Location Cross Streets',
			sort         : 'string',
			filter       : 'string',
			order        : 22,
			filterColumn : 'location.description',
		}
	},

	dropdownOptions : {
		status : {
			defaultText : 'Select a status',
			options     : [
				{
					text  : 'Open',
					value : 'Open'
				},
				{
					text  : 'Closed',
					value : 'Closed'
				},
				{
					text  : 'Voided',
					value : 'Voided'
				},
			]
		},
		permitsTypeDescription : {
			defaultText : 'Select a Type',
			options     : [
				{
					text  : 'Permit To Install Structure',
					value : 'Permit To Install Structure'
				},
				{
					text  : 'Permit To Work Within Easement & Right-of-Way',
					value : 'Permit To Work Within Easement & Right-of-Way'
				},
				{
					text  : 'Temp. Permit To Pump Construction Water From Canal',
					value : 'Temp. Permit To Pump Construction Water From Canal'
				},
				{
					text  : 'Permit For Removal Of Borrow Material',
					value : 'Permit For Removal Of Borrow Material'
				},
				{
					text  : 'Voided Permit No.',
					value : 'Voided Permit No.'
				},
				{
					text  : 'Permit of Access',
					value : 'Permit of Access'
				},
				{
					text  : 'Permit To Install Structure (Stream)',
					value : 'Permit To Install Structure (Stream)'
				},
				{
					text  : 'Permit To Discharge Well Development Water To Canal Facility',
					value : 'Permit To Discharge Well Development Water To Canal Facility'
				},
				{
					text  : 'Permit To Work Within Easement & Right-of-Way (Stream)',
					value : 'Permit To Work Within Easement & Right-of-Way (Stream)'
				},
			]
		}
	}
};
